import api from './api';

const state = {
	absenceStatistics: [],
	totals: [],
	error: false,
	message: '',
};

const getters = {};

const mutations = {
	setAbsenceStatistics(state, stats) {
		state.absenceStatistics = stats.drivers;
		state.totals = stats.totals;
	},
	setError(state, { message }) {
		(state.error = true), (state.message = message);
	},
};

const actions = {
	async loadAbsenceStatistics({ commit }, payload) {
		try {
			const response = await api.getAbsenceStatistics(payload);
			const stats = response.data;
			commit('setAbsenceStatistics', stats);
		} catch (err) {
			commit('setError', { message: err.response.data.message });
			return null;
		}
	},
};

export default {
	namespaced: true,
	state,
	getters,
	actions,
	mutations,
};
